import { useSuspenseQuery } from "@tanstack/react-query";
import { MyHotel } from "./MyHotel";
import { MyFlight } from "./MyFlight";
import { ReservationType } from "@/app/lib/types/enums";
import { OrderDetailsWithoutReservation } from "./OrderDetailsWithoutReservation";
import { reservationQueryOptions } from "@/app/lib/hooks/useReservations";
import { tripBookingQueryOptions } from "@/app/lib/hooks/useTripBookings";
import type { SearchScope } from "@/app/lib/types/types";
import { MyTrip } from "../trips/bookingDetails/MyTrip";

interface Props {
  reservationId: string;
  scope: SearchScope;
}

export const MyBooking = ({ scope, reservationId }: Props) => {
  if (scope === "hotels") {
    return <MyHotelReservation reservationId={reservationId} />;
  }

  if (scope === "flights") {
    return <MyFlightOrder reservationId={reservationId} />;
  }

  if (scope === "trips") {
    return <MyTripOrder reservationId={reservationId} />;
  }

  return null;
};

function MyHotelReservation({ reservationId }: { reservationId: string }) {
  const { data } = useSuspenseQuery(reservationQueryOptions(reservationId));

  const reservation = data.hotelReservation;

  return reservation.status === ReservationType.REFUNDED ||
    !reservation.externalReservation ? (
    <OrderDetailsWithoutReservation reservation={reservation} />
  ) : (
    <MyHotel reservation={reservation} />
  );
}

function MyFlightOrder({ reservationId }: { reservationId: string }) {
  const { data } = useSuspenseQuery(reservationQueryOptions(reservationId));

  const reservation = data.flightReservation;

  return !reservation.externalReservation ? (
    <OrderDetailsWithoutReservation reservation={reservation} />
  ) : (
    <MyFlight reservation={reservation} status={reservation.status} />
  );
}

function MyTripOrder({ reservationId }: { reservationId: string }) {
  const { data } = useSuspenseQuery(tripBookingQueryOptions(reservationId));

  const reservation = data.packageBooking;

  return <MyTrip reservation={reservation} />;
}
